var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"paid-status-badge",style:(_setup.badgeStyle)},[(_setup.statusIcon)?_c('md-icon',{style:(_setup.iconStyle)},[_vm._v(_vm._s(_setup.statusIcon))]):_vm._e(),_c('span',[_vm._v(_vm._s(_setup.statusTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }